import mitt from "mitt";
export const clientFetchEventsEmitter = mitt();
